export default "__VITE_PUBLIC_ASSET__df6e600e__"